interface SportFundLogoProps {
    className?: string;
    title?: string;
}

export default function SportFundLogo({ className, title = 'Sport Fund' }: SportFundLogoProps) {
    return (
        <svg
            viewBox="0 0 520 130"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label={title}
            className={className}
            preserveAspectRatio="xMinYMid meet"
        >
            <defs>
                <linearGradient id="sf-sunrise" gradientUnits="userSpaceOnUse" x1="30" y1="97" x2="94" y2="31">
                    <stop offset="0" stopColor="#FF5E3A" />
                    <stop offset="1" stopColor="#FFB13B" />
                </linearGradient>
            </defs>
            <g transform="translate(12,15)">
                <g stroke="url(#sf-sunrise)" strokeWidth="13" strokeLinecap="round">
                    <line x1="24" y1="80" x2="29" y2="64" />
                    <line x1="42" y1="80" x2="52" y2="48" />
                    <line x1="60" y1="80" x2="75" y2="30" />
                </g>
                <circle cx="79" cy="18" r="5" fill="url(#sf-sunrise)" />
            </g>
            <text
                x="132"
                y="86"
                fontFamily="'Space Grotesk', system-ui, Arial, sans-serif"
                fontSize="64"
                fontWeight="700"
                letterSpacing="-2"
            >
                <tspan fill="currentColor">Sport</tspan>
                <tspan fill="#FFB13B">Fund</tspan>
            </text>
        </svg>
    );
}
